/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AzureObjectStoreTransferConfig = {
    container: string;
    prefix: string;
    provider?: AzureObjectStoreTransferConfig.provider;
    account: string;
    endpoint: string;
    sas_token: string;
};

export namespace AzureObjectStoreTransferConfig {

    export enum provider {
        AZURE = 'azure',
    }


}

